import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { get, isFunction } from 'lodash';

@Component({
  selector: 'xvi-switch-renderer',
  templateUrl: './switch-renderer.component.html',
  styleUrls: ['./switch-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchRendererComponent implements ICellRendererAngularComp {
  public value: boolean = false;
  public params: ICellRendererParams;
  public isDisabled: boolean = false;
  public label: string = '';
  public labelNameMap: { [key: string]: string } = {
    true: I18n.Common.Yes,
    false: I18n.Common.No,
  };

  public constructor(
    private readonly cdr: ChangeDetectorRef,
    public i18nService: XVII18nService,
  ) {}

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = !!params.value;
    this.isDisabled = get(this.params, 'disabled', false);
    this.label = this.i18nService.instant(
      this.labelNameMap[String(this.value)],
    );

    this.cdr.detectChanges();
  }

  public refresh(params: ICellRendererParams): boolean {
    this.params = params;
    const newValue =
      params?.value !== undefined
        ? params.value
        : params?.data?.[params?.colDef?.field || ''];

    if (this.value !== newValue) {
      this.value = newValue;
      this.cdr.detectChanges();
    }

    return true;
  }

  public onSwitchChange(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (this.isDisabled) {
      return;
    }

    const newValue = !this.value;

    let onValueChange = get(this.params, [
      'cellRendererParams',
      'onValueChange',
    ]);

    if (!onValueChange) {
      onValueChange = get(this.params, 'onValueChange');
    }

    if (isFunction(onValueChange)) {
      onValueChange(newValue, this.params.data, this.params);
    }
  }
}
